export const sonFormSel = {
  input: '单行文本',
  textarea: '多行文本',
  select: '下拉选择框',
  time: '时间选择器',
  date: '日期选择器',
  hidden: '隐藏域',
  number: '计数器',
  radio: '单选框组',
  checkbox: '多选框组',
  rate: '评分',
  switch: '开关',
  color: '颜色选择器',
  slider: '滑块',
}
